import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const routes =[
  {
    path: '/',
    name: 'Home',
    // 路由守卫
    // meta: { requireAuth: true },
    component:resolve => require(['@/pages/Home'],resolve)//路由按需加载
  },
  //列表
  {
    path: '/List',
    name: 'List',
    component:resolve => require(['@/pages/List'],resolve)
  },
  //院系列表
  {
    path: '/YuanXiList',
    name: 'YuanXiList',
    component:resolve => require(['@/pages/yuanxifengcai/YuanXiList'],resolve)
  },
  //详情
  {
    path: '/Detail',
    name: 'Detail',
    component:resolve => require(['@/pages/Detail'],resolve)
  },
  //院系详情
  {
    path: '/YuanXiDetail',
    name: 'YuanXiDetail',
    component:resolve => require(['@/pages/yuanxifengcai/YuanXiDetail'],resolve)
  },
  //单页新闻
  {
    path: '/InfoShow',
    name: 'InfoShow',
    component:resolve => require(['@/pages/InfoShow'],resolve)
  },
  //登录
  {
    path: '/Login',
    name: 'Login',
    component:resolve => require(['@/pages/login/Login'],resolve)
  },
  //预报道成功
  // {
  //   path: '/',
  //   name: 'LoginSuc',
  //   // meta: { requireAuth: true },
  //   component:resolve => require(['@/pages/login/LoginSuc'],resolve)
  // },
  //新生预报道说明
  {
    path: '/ForecastExplain',
    name: 'ForecastExplain',
    component:resolve => require(['@/pages/forecast/ForecastExplain'],resolve)
  },
  //新生预报道第一步  个人基本信息
  {
    path: '/BaseInfo',
    name: 'BaseInfo',
    component:resolve => require(['@/pages/forecast/BaseInfo'],resolve)
  },
  //新生预报道第二步  家庭信息
  {
    path: '/FamilyInfo',
    name: 'FamilyInfo',
    component:resolve => require(['@/pages/forecast/FamilyInfo'],resolve)
  },
  //新生预报道第三步  绿色通道
  {
    path: '/GreenRoad',
    name: 'GreenRoad',
    component:resolve => require(['@/pages/forecast/GreenRoad'],resolve)
  },
    //缴费信息
  {
    path: '/PaymentInfo',
    name: 'PaymentInfo',
    component:resolve => require(['@/pages/forecast/PaymentInfo'],resolve)
  },
  //新生预报道第四步  其他信息
  {
    path: '/OtherInfo',
    name: 'OtherInfo',
    component:resolve => require(['@/pages/forecast/OtherInfo'],resolve)
  },
  //新生预报道第五步  确认信息
  {
    path: '/SureInfo',
    name: 'SureInfo',
    component:resolve => require(['@/pages/forecast/SureInfo'],resolve)
  },
   //新生预报道第步  在线选宿舍
   {
    path: '/Dormitory',
    name: 'Dormitory',
    component:resolve => require(['@/pages/forecast/Dormitory'],resolve)
  },
  //班级成员信息
  {
    path: '/ClassmatesInfo',
    name: 'ClassmatesInfo',
    component:resolve => require(['@/pages/forecast/ClassmatesInfo'],resolve)
  },
 {//404
  path: '/NotFound',
  name: 'NotFound',
  component: resolve => require(['@/pages/NotFound'], resolve),
}
]
const router =new Router({
  // mode:'history',
  routes ,
  // base: "/" + document.location.pathname.split('/')[1] + "/"        
});

router.beforeEach((to,from,next) => {
    const token =sessionStorage.getItem("token");
    if(to.meta.requireAuth){//在router需要的路由页面加入路由守卫,meta: { requireAuth: true },将开启你的页面路由守卫
      if(token){//登录
        next()
      }else{//未登录
        // next({path:"/Login",query:{redirect:to.fullPath}})   //把要跳转的地址作为参数传到下一步
      }
    }else{
      next()
    }
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js